// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"_5282ad","saveAndCountContainer":"_3244b6","saveCount":"_3d9fff","saveButtonText":"_161f3b","onlyIcon":"_dc2388","saveButtonContent":"_9a422d"};